export const UPDATE_TIMEZONE = 'UPDATE_TIMEZONE';
export const UPDATE_TIMEZONE_SUCCESS = 'UPDATE_TIMEZONE_SUCCESS';

export const updateTimezoneAction = (payload:any) => ({
    type: UPDATE_TIMEZONE,
    ...payload
}
);